// This componet is a transition page showing the title of Syncing to your calendar

/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { useStyles } from './styles';
import ContentContainer from '../../components/contentContainer';
import WidgetDialog from '../../components/dialogs';
import TitleHeader from '../../components/titleHeader';
import useWidgetTheme from '../../../commons/widgetTheme';
import TranslationIds from '../../../commons/translationIds';
import useTranslator from '../../../commons/translations';
import EcalLogo from '../../../commons/images/EcalLogo';
import useUIStates from '../../../store/models/uistates/useUIStates';

import usePageTransitions from '../../../store/models/animations/usePageTransitions';
import {
    TransitionViewNames,
} from '../../../store/models/animations/actions/transitions';

import useKickstarted from '../../../commons/hooks/useKickstarted';

function OauthProcessing (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;
    
    const  {
        translate,
        translateWithValues,
    } = useTranslator();

    const {
        selectedCalendar,
        appStore,
    } = useUIStates();

    const {
        widget,
        widgetTheme,
    }  = useWidgetTheme();

    const classes = useStyles({
        widget,
        widgetTheme,
        flags: appStore.flags,
    });

    useKickstarted({
        onKickstarted: () => {},
    });

    usePageTransitions({
        elementName: TransitionViewNames.OAUTH_LOADING_VIEW,
        viewAnimation,
    });

    if (!appStore.kickstarted) {
        return (<React.Fragment></React.Fragment>);
    }

    return (
        <React.Fragment>
            <ContentContainer
                viewAnimation={viewAnimation}
            >
                <WidgetDialog
                    isShowCloseButton={false}
                    isShowBackButton={false}
                    name={TransitionViewNames.OAUTH_LOADING_VIEW}
                    viewAnimation={viewAnimation}
                    initStyles={initStyles}
                >

                    <Grid className={classes.titleHeader}>
                        <TitleHeader
                            widget={widget}
                            widgetTheme={widgetTheme}
                            title={translateWithValues(TranslationIds.COMPONENT_PROGRESS_INDICATOR_INFO,
                                {
                                    calendar: selectedCalendar,
                                }
                            )}
                        />
                    </Grid>

                    <Grid className={classes.loadingBox}>
                        <EcalLogo />
                    </Grid>

                    <Grid className={classes.contentBody}>
                        <Typography
                            variant={'body1'}
                            className={classes.subInfoMessage}
                        >
                            {translate(TranslationIds.COMPONENT_SUB_INFO)}
                        </Typography>
                    </Grid>
                </WidgetDialog>
            </ContentContainer>           
        </React.Fragment>
    );
}

OauthProcessing.propTypes = {
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};


export default observer(OauthProcessing);
